
<h1> {{data.id}}</h1>
<div>

  <div *ngFor="let row of data.line_items">
    {{row.quantity}}x {{row.name}}
  </div>
</div>
